/*

    <a href='https://airtable.com/shrzMcypjWPdZaeLL'>Rent Roll Increase</a>
    <a href='portalhelp@mbhp.org'>Account Support/Assistance</a>
    <a href='gateway@metrohousingboston.org'>Questions on Account</a>
*/
import { Form } from 'react-bootstrap';

import React, { useState, useEffect } from 'react';


import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import HAPPYPAYMENTS from './HAPPYPAYMENTS';
import S8PAYMENTS from './S8PAYMENTS';
import RENTSHARE from './RENTSHARE';
import MRVPPAYMENTS from './MRVPPAYMENTS';
import WSDPAYMENTS from './WSDPAYMENTS';

import { findAccountByEmail } from '../pages/Register';
import { Auth } from 'aws-amplify';
/**
 * Navigation Menu section for Links on website
 * @returns 
 * 
 *    
 * Removed Code Below (Header Logo icon on left)         
<a className='navbar-brand' href='/#'>
    Metro Housing Boston
</a>
 */

const exportExcel = (sheetsData, fileName) => {
    const wb = XLSX.utils.book_new();

    Object.entries(sheetsData).forEach(([sheetName, data]) => {
        const ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(dataBlob, `${fileName}.xlsx`);
};

const STORAGE_VISIBLE_TYPES_KEY = 'PAYMENTS_VISIBLE_TYPES';

const getSavedVisibleTypes = () => {
    try {
        const raw = localStorage.getItem(STORAGE_VISIBLE_TYPES_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return parsed;
        return null;
    } catch {
        return null;
    }
};

const maskTaxId = (taxId) => {
    const digits = `${taxId || ''}`.replace(/\D/g, '');
    const lastFour = digits.slice(-4);

    if (!lastFour) return '***-**-****';

    return `***-**-${lastFour.padStart(4, '*')}`;
};

export default function Payments() {
    const currentYear = new Date().getFullYear();
    const [rPayments, setRPayments] = useState([]);
    const [sPayments, setSPayments] = useState([]);
    const [hPayments, setHPayments] = useState([]);
    const [mPayments, setMPayments] = useState([]);
    const [wPayments, setWPayments] = useState([]);

    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(false);

    const [userPropertyList, setUserPropertyList] = useState([]);
    const [selectedTaxId, setSelectedTaxId] = useState();

    const [visibleTypes, setVisibleTypes] = useState(() => {
        const saved = getSavedVisibleTypes();
        return saved || {
            RENTSHARE: true,
            S8: true,
            HAPPY: true,
            MRVP: true,
            WSD: true,
        };
    });

    const toggleType = (key) => {
        setVisibleTypes(prev => ({ ...prev, [key]: !prev[key] }));
    };

    useEffect(() => {
        localStorage.setItem(STORAGE_VISIBLE_TYPES_KEY, JSON.stringify(visibleTypes));
    }, [visibleTypes]);

    const fetchUserDetails = async () => {
        try {
            setLoading(true);
            const currentUserInfo = await Auth.currentUserInfo();
            // console.log(currentUserInfo.attributes.email, currentUserInfo)
            const response = await findAccountByEmail(currentUserInfo.attributes.email);
            const properties = response?.rows || [];
            setUserPropertyList(properties);
            if (properties.length > 0) {
                setSelectedTaxId((previousSelectedTaxId) => previousSelectedTaxId || properties[0].U_PROPERTY_TAXID);
            }
        } catch (error) {
            console.log('Error fetching payments:', error);
        } finally {
            setLoading(true);
        }
    };

    useEffect(() => {
        fetchUserDetails();
    }, []);

    return (
        <div className='userdata paymentsdata'>
            <div className='rentShareUpdate payments'  >
                <h3 className='text-center  payments-heading'>{currentYear} PAYMENTS</h3>
                <div className='myProperties exportOptions margin hide' >
                    <h5 className='emphTitle'>My Properties</h5>

                        <p className='emphTitle'> Updates In Progress </p>

                        {
                            /* List of Users Properties shown in format below 
                                PROPERTY NAME    |   PROPERTY TAX ID
                                PROPERTYN_NAME_A |   123-45-6789
                                PROPERTYN_NAME_B |   153-45-6710
                                PROPERTYN_NAME_C |   742-45-2389
                            */
                        }

                    <table className='table bg-transparent'>
                        <thead>
                            <tr>
                                <th className='bg-transparent text-white'>Property Name</th>
                                <th className='bg-transparent text-white'>Property Tax ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                userPropertyList.map((property, index) => (
                                    <tr key={index}>
                                        <td className='bg-transparent text-white'>{property.PROPERTY_NAME}</td>
                                        <td className='bg-transparent text-white'>{property.U_PROPERTY_TAXID}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>

                </div>
                
                <div className='d-flex justify-content-center flex-wrap gap-2 align-items-center mt-4'>
                    <label className=' emphTitle '>Select Property</label>
                    <Form.Select style={{ maxWidth: 'max-content' }} value={selectedTaxId} onChange={(ev) => setSelectedTaxId(ev.target.value)}>
                        {
                            userPropertyList.map((property) => (
                                <option value={property.U_PROPERTY_TAXID} key={property.U_PROPERTY_TAXID}>{property.PROPERTY_NAME} | {property.U_PROPERTY_TAXID}</option>
                            ))
                        }
                    </Form.Select>
                </div>
                <div className='myProperties margin mt-4'>
                    <h5 className='emphTitle text-center'>My Properties</h5>
                    <div className='table-responsive'>
                        <table className='table mx-auto' style={{ width: '50%' }}>
                            <thead>
                                <tr>
                                    <th>Property Name</th>
                                    <th>Property Tax ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userPropertyList.length === 0 ? (
                                    <tr>
                                        <td colSpan="2" className='text-center'>No properties found for this account.</td>
                                    </tr>
                                ) : (
                                    userPropertyList.map((property) => {
                                        const isSelected = property.U_PROPERTY_TAXID === selectedTaxId;

                                        return (
                                            <tr key={property.U_PROPERTY_TAXID}>
                                                <td style={isSelected ? { backgroundColor: '#f8d7da' } : undefined}>{property.PROPERTY_NAME}</td>
                                                <td style={isSelected ? { backgroundColor: '#f8d7da' } : undefined}>{maskTaxId(property.U_PROPERTY_TAXID)}</td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='exportOptions hide'>
                    <h5 className='text-center emphTitle'>EXPORT OPTIONS</h5>
                    <div className='emphTitle margin'>
                        <input
                            type="radio"
                            value="Option 1"
                            defaultChecked
                        />
                        2024-2026 PAYMENTS
                    </div>
                    <button className='exportDataBTN btn btn-primary' onClick={() => exportExcel({ "S8 Payments": sPayments }, 'S8 Payments')}>Export S8</button>
                    <button className='exportDataBTN btn btn-primary' onClick={() => exportExcel({ "RAFT Payments": hPayments }, 'RAFT Payments')}>Export RAFT</button>
                    <button className='exportDataBTN btn btn-primary' onClick={() => exportExcel({ "MRVP Payments": mPayments }, 'MRVP Payments')}>Export MRVP</button>
                    <button className='exportDataBTN btn btn-primary' onClick={() => exportExcel({ "MRVP Payments": wPayments }, 'WSD Payments')}>Export WSD</button>
                    <hr></hr>
                    <br></br>
                    <button className='exportDataBTN btn btn-primary' onClick={() => {
                            exportExcel(
                                {
                                    "S8 Payments": sPayments,
                                    "RAFT Payments": hPayments,
                                    "MRVP Payments": mPayments,
                                    "WSD Payments": wPayments,
                                },
                                'S8, RAFT, MRVP, WSD Payments'
                            )
                        }}
                        >Export All
                    </button>
                    <br></br>
                    <br></br>

                </div>
                <br></br>
            </div>

            <div className='d-flex justify-content-center flex-wrap gap-3 align-items-center mt-4'>
                <h3 className='black-text taLabel emphTitle'>Hide/Show payment types:</h3>
                <label className='d-flex align-items-center gap-1'>
                    <input
                        type="checkbox"
                        checked={visibleTypes.RENTSHARE}
                        onChange={() => toggleType('RENTSHARE')}
                    />
                    RENTSHARE
                </label>
                <label className='d-flex align-items-center gap-1'>
                    <input
                        type="checkbox"
                        checked={visibleTypes.S8}
                        onChange={() => toggleType('S8')}
                    />
                    SECTION 8
                </label>
                <label className='d-flex align-items-center gap-1'>
                    <input
                        type="checkbox"
                        checked={visibleTypes.HAPPY}
                        onChange={() => toggleType('HAPPY')}
                    />
                    RAFT/HOMEBASE
                </label>
                <label className='d-flex align-items-center gap-1'>
                    <input
                        type="checkbox"
                        checked={visibleTypes.MRVP}
                        onChange={() => toggleType('MRVP')}
                    />
                    MRVP
                </label>
                <label className='d-flex align-items-center gap-1'>
                    <input
                        type="checkbox"
                        checked={visibleTypes.WSD}
                        onChange={() => toggleType('WSD')}
                    />
                    WSD
                </label>
            </div>

            <br></br>


            {visibleTypes.RENTSHARE && (
                <RENTSHARE payments={rPayments} setPayments={setRPayments} taxId={selectedTaxId} />
            )}

            {visibleTypes.S8 && (
                <S8PAYMENTS payments={sPayments} setPayments={setSPayments} taxId={selectedTaxId} />
            )}

            {visibleTypes.HAPPY && (
                <HAPPYPAYMENTS payments={hPayments} setPayments={setHPayments} taxId={selectedTaxId} />
            )}

            {visibleTypes.MRVP && (
                <MRVPPAYMENTS payments={mPayments} setPayments={setMPayments} taxId={selectedTaxId} />
            )}

            {visibleTypes.WSD && (
                <WSDPAYMENTS payments={wPayments} setPayments={setWPayments} taxId={selectedTaxId} />
            )}


        </div>
    );
}

/*

    <a href='https://airtable.com/shrzMcypjWPdZaeLL'>Rent Roll Increase</a>
    <a href='portalhelp@mbhp.org'>Account Support/Assistance</a>
    <a href='gateway@metrohousingboston.org'>Questions on Account</a>
*/
